// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollbar::-webkit-scrollbar{width:6px;height:6px;background-color:#e9e9e9}.scrollbar::-webkit-scrollbar-thumb{background:#d1d1d1;border-radius:6px;width:6px}[v-cloak]{display:none}.index-container{background-color:#fff;border-radius:12px;font-size:14px}.index-container *{box-sizing:border-box}/deep/ .el-button--primary{background-color:#ffa54b;border-color:#ffa54b;width:90px!important;height:38px;border-radius:6px}", ""]);
// Exports
module.exports = exports;
